import React from 'react';

import { Grid, Stack } from '@mui/material';

import { DashboardGlobalCVAdminUsageReportsBlock } from 'src/components/dashboard/components/DashboardGlobalCVAdmin/DashboardGlobalCVAdminUsageReportsBlock';
import { DashboardGlobalCVAdminWorkLetterUsageBlock } from 'src/components/dashboard/components/DashboardGlobalCVAdmin/DashboardGlobalCVAdminWorkLetterUsageBlock';
import { useDashboardCVAdminData, useDashboardPrintView } from 'src/hooks/dashboard';
import { DEFAULT_DASHBOARD_CV_ADMIN_CONTEXT } from 'src/providers/DashboardCVAdminProvider';

import { NOW } from '../constants';
import { DashboardFilterCVAdmin } from '../DashboardFilterCVAdmin';
import { DashboardFilterPreviewPrint } from '../DashboardFilterPreviewPrint';
import { DashboardOverviewBlock } from '../DashboardOverviewBlock';

import { DashboardGlobalCVAdminRecordsActivityBlock } from './DashboardGlobalCVAdminRecordsActivityBlock';

export const DashboardGlobalCVAdmin: React.FC = () => {
  const { isPrintView } = useDashboardPrintView();
  const { setDate, setEmployers, setPeos, setUsageReportStartDate, setUsageReportEndDate } =
    useDashboardCVAdminData();

  React.useEffect(() => {
    if (!isPrintView) {
      setPeos(DEFAULT_DASHBOARD_CV_ADMIN_CONTEXT.peos);
      setDate(NOW);
      setEmployers(DEFAULT_DASHBOARD_CV_ADMIN_CONTEXT.employers);
      setUsageReportStartDate(DEFAULT_DASHBOARD_CV_ADMIN_CONTEXT.usageReportStartDate);
      setUsageReportEndDate(DEFAULT_DASHBOARD_CV_ADMIN_CONTEXT.usageReportEndDate);
    }
  }, [isPrintView, setDate, setPeos, setEmployers, setUsageReportEndDate, setUsageReportStartDate]);

  return (
    <Grid container spacing={3} pt={4} padding={isPrintView ? 4 : 'none'}>
      <Grid size={12}>
        <DashboardFilterCVAdmin disableDateButton />
      </Grid>
      <Grid
        display="flex"
        size={{
          xs: isPrintView ? 6 : 12,
          lg: 6,
        }}
      >
        <DashboardOverviewBlock />
      </Grid>
      <Grid
        display="flex"
        size={{
          xs: isPrintView ? 6 : 12,
          lg: 6,
        }}
      >
        <DashboardGlobalCVAdminRecordsActivityBlock />
      </Grid>
      <Grid size={12}>
        <Stack spacing={3}>
          <DashboardGlobalCVAdminUsageReportsBlock />
          <DashboardGlobalCVAdminWorkLetterUsageBlock />
        </Stack>
      </Grid>
      {isPrintView ? (
        <Grid size={12}>
          <DashboardFilterPreviewPrint />
        </Grid>
      ) : null}
    </Grid>
  );
};
